import { useQuery } from "@apollo/client";
import { gql } from "types";

const FIND_ENVIRONMENT_DOCUMENTS = gql(/* GraphQL */ `
  query FindEnvironmentDocuments($environmentId: String!) {
    findEnvironmentDocuments(environmentId: $environmentId) {
      id
      titles
      files
      type
    }
  }
`);

export function useEnvironmentDocuments(environmentId: string) {
  const { data, loading, refetch } = useQuery(FIND_ENVIRONMENT_DOCUMENTS, {
    variables: { environmentId },
    skip: !environmentId,
  });

  return {
    documents: data?.findEnvironmentDocuments ?? [],
    loading,
    refetch,
  };
}

export { FIND_ENVIRONMENT_DOCUMENTS };
